<template>
    <div>
        <b-input-group>
            <b-form-input disabled :value="fileName"></b-form-input>
            <b-input-group-append>
                <b-button
                    title="Load file"
                    :href="documentUrl"
                    target="_blank"
                    :disabled="!value"
                >
                    <b-icon icon="cloud-download" aria-hidden="true"></b-icon>
                </b-button>
                <b-button
                    v-if="!disabled"
                    @click="is_visible = true"
                    variant="outline-primary"
                >
                    <b-icon icon="cloud-upload"></b-icon>
                </b-button>
            </b-input-group-append>
        </b-input-group>

        <b-modal :id="uploadKey" v-model="is_visible" title="Upload Document">
            <b-form-file id="uploadData" @change="uploadFile"></b-form-file>
        </b-modal>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    mixins: [popupMixins],
    data() {
        return {
            key: null,
            fileName: null,
            is_visible: false,
            uploadKey: 0,
        }
    },

    props: ['value', 'disabled'],
    computed: {
        documentUrl() {
            return `${this.$OMSStorageUrl}/${this.key}`
        },
    },
    watch: {
        is_visible: function (val) {
            console.log('is_visible', val)
            if (!val) this.key = this.value
        },
        value: function (val) {
            this.convertValue(val)
        },

        key: function (val) {
            console.log('watch: key', val)
            const obj = { key: val, name: this.fileName, url: this.documentUrl }
            this.$emit('input', JSON.stringify(obj))
            this.is_visible = false
        },
    },
    created() {
        this.uploadKey =
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15)
    },
    mounted() {
        this.convertValue(this.value)
    },
    methods: {
        convertValue(value) {
            try {
                const obj = JSON.parse(value)
                this.key = obj.key
                this.fileName = obj.name
            } catch (err) {
                this.key = value
                this.fileName = value
            }
        },
        async uploadFile(event) {
            console.log(event.target.files)
            ;({ key: this.key, name: this.fileName } =
                await this.$store.dispatch(
                    's3files/s3upload',
                    event.target.files
                ))
        },
    },
}
</script>